import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Estudos Compensatórios de Infrequência (ECI)',
    path: '/academico/estudos_compensatorios',
    name: 'estudos_compensatorios',
    component: () => import('@/views/academico/estudoscompensatorios/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.ESTUDOSCOMPENSATORIOS_300300017
      ],
    },
    goesToMenu: true,
  }
]

